var map = {
	"./central-desktop.jpg": 45025,
	"./default-desktop.jpg": 5701,
	"./mandurah-times-desktop.jpg": 77573,
	"./north-desktop.jpg": 3607,
	"./northern-suburbs-desktop.jpg": 4413,
	"./south-desktop.jpg": 23133,
	"./western-suburbs-desktop.jpg": 21721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58136;